import React, { useCallback } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import styles from "../Onboarding.module.scss";
import Select from "../../../common/components/Select";
import Button from "../../../common/components/Button";

const AboutProject = (props) => {
  const { t } = useTranslation();
  const {
    onNextStep,
    onPreviousStep,
    aboutInfo,
    setAboutInfo,
    forWhoOptions,
    projectSizeOptions,
  } = props;

  const isReadyToNextStep = useCallback(() => {
    if (
      _.isEmpty(aboutInfo.forWho) ||
      _.isEmpty(aboutInfo.projectSize) ||
      _.isEmpty(aboutInfo.teamName)
    ) {
      return false;
    }

    return true;
  }, [aboutInfo]);

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <h2>{t("onboard.about_project")}</h2>
      </div>
      <form
        onSubmit={(e) => {
          onNextStep(e, { ...aboutInfo });
        }}
      >
        <div className={styles.inputContainer}>
          <label htmlFor="forWho">{t("onboard.for_who.title")}</label>
          <Select
            className={styles.inputSelect}
            options={forWhoOptions}
            onChange={(e) => {
              const forWho = e.value;
              setAboutInfo((infos) => ({
                ...infos,
                forWho,
              }));
            }}
            value={
              aboutInfo.forWho
                ? {
                    value: aboutInfo.forWho,
                    label: t(`onboard.for_who.${aboutInfo.forWho}`),
                  }
                : { value: "", label: "" }
            }
            name="forWho"
            id="forWho"
            required
          />

          <label htmlFor="projectSize">{t("onboard.project_size.title")}</label>
          <Select
            className={styles.inputSelect}
            options={projectSizeOptions}
            onChange={(e) => {
              const projectSize = e.value;
              setAboutInfo((infos) => ({
                ...infos,
                projectSize,
              }));
            }}
            value={
              aboutInfo.projectSize
                ? {
                    value: aboutInfo.projectSize,
                    label: t(`onboard.project_size.${aboutInfo.projectSize}`),
                  }
                : { value: "", label: "" }
            }
            name="projectSize"
            id="projectSize"
            required
          />

          <label htmlFor="given-name">{t("onboard.team_name")}</label>
          <input
            value={aboutInfo.teamName}
            onChange={(e) => {
              const teamName = e.target.value;
              setAboutInfo((infos) => ({
                ...infos,
                teamName,
              }));
            }}
            type="text"
            placeholder={t("onboard.team_name")}
            id="teamName"
            name="teamName"
            required
          />
          <label htmlFor="eventDate">{t("onboard.event_date")}</label>
          <input
            value={aboutInfo.eventDate}
            onChange={(e) => {
              let eventDate = e.target.value;
              // if(!eventDate){
              //   eventDate=null;
              // }
              setAboutInfo((infos) => ({
                ...infos,
                eventDate,
              }));
            }}
            type="date"
            placeholder={t("onboard.event_date")}
            id="eventDate"
            name="eventDate"
            min={new Date().toISOString().split("T")[0]}
          />

          <span className={styles.changeLaterTitle}>
            {t("onboard.change_later")}
          </span>
        </div>
        <div className={styles.actionContainer}>
          <Button disabled={!isReadyToNextStep()}>
            {t("onboard.get_started")}
          </Button>
          <Link to="" onClick={(e) => onPreviousStep(e)}>
            {t("onboard.back")}
          </Link>
        </div>
      </form>
    </div>
  );
};

export default AboutProject;
